import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import Header from './header/Header';
// import Customizer from './customizer/Customizer';
import Sidebar from './sidebars/vertical/Sidebar';
import HorizontalHeader from './header/HorizontalHeader';
import HorizontalSidebar from './sidebars/horizontal/HorizontalSidebar';
import AppLogout from '../components/common/AppLogout';

const FullLayout = () => {
  // const customizerToggle = useSelector((state) => state.customizer.customizerSidebar);
  const toggleMiniSidebar = useSelector((state) => state.customizer.isMiniSidebar);
  const showMobileSidebar = useSelector((state) => state.customizer.isMobileSidebar);
  const topbarFixed = useSelector((state) => state.customizer.isTopbarFixed);
  const LayoutHorizontal = useSelector((state) => state.customizer.isLayoutHorizontal);
  const isFixedSidebar = useSelector((state) => state.customizer.isSidebarFixed);

  return (
    <main className='retailer-layout'>
      <div
        className={`pageWrapper d-md-block ${toggleMiniSidebar ? 'isMiniSidebar' : ''}`}
      >
        <div className={`contentArea ${topbarFixed ? 'fixedTopbar' : ''}`}>
          <AppLogout>
            {LayoutHorizontal ? <HorizontalHeader /> : <Header />}
            {LayoutHorizontal ? <HorizontalSidebar /> : ''}

            <div className="d-flex">
                {LayoutHorizontal ? (
                  ''
                ) : (
                  <aside className={`sidebarArea ${showMobileSidebar ? 'showSidebar' : ''}`}>
                    <Sidebar />
                  </aside>
                )}
                <Container fluid className="p-3 boxContainer">
              <div className={isFixedSidebar && LayoutHorizontal ? 'HsidebarFixed' : ''}>
                <Outlet />
              </div>
              </Container>
            </div>
          </AppLogout>
        </div>
      </div>
    </main>
  );
};

export default FullLayout;
